var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSearchFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 105.998,
    height: 94,
    viewBox: "0 0 105.998 94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1472",
    "data-name": "Grupo 1472",
    transform: "translate(-865 -460)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "folder_managed_24dp_E8EAED_FILL1_wght400_GRAD0_opsz24",
    d: "M88.192-734.461a7.888,7.888,0,0,1-5.786-2.406A7.889,7.889,0,0,1,80-742.654v-49.154a7.889,7.889,0,0,1,2.407-5.786A7.889,7.889,0,0,1,88.192-800h24.577l8.192,8.192h32.769a7.888,7.888,0,0,1,5.786,2.406,7.889,7.889,0,0,1,2.406,5.786V-770.2a27.722,27.722,0,0,0-7.783-3.891,28.625,28.625,0,0,0-8.7-1.331,27.28,27.28,0,0,0-20.327,8.448,27.818,27.818,0,0,0-8.244,20.122,27.85,27.85,0,0,0,.717,6.349,29.065,29.065,0,0,0,2.151,6.042Z",
    transform: "translate(785 1260)",
    fill: "#d2e0e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "search_24dp_E8EAED_FILL1_wght400_GRAD0_opsz24",
    d: "M178.787-776.256l-22.311-22.31a21.108,21.108,0,0,1-6.109,3.364,21.582,21.582,0,0,1-7.348,1.239,22.221,22.221,0,0,1-16.334-6.684A22.221,22.221,0,0,1,120-816.981a22.219,22.219,0,0,1,6.684-16.334A22.219,22.219,0,0,1,143.019-840a22.219,22.219,0,0,1,16.335,6.685,22.219,22.219,0,0,1,6.684,16.334,21.583,21.583,0,0,1-1.239,7.348,21.1,21.1,0,0,1-3.364,6.109l22.311,22.311Zm-35.768-24.789a15.368,15.368,0,0,0,11.288-4.648,15.368,15.368,0,0,0,4.648-11.288,15.368,15.368,0,0,0-4.648-11.288,15.367,15.367,0,0,0-11.288-4.648,15.367,15.367,0,0,0-11.288,4.648,15.368,15.368,0,0,0-4.648,11.288,15.368,15.368,0,0,0,4.648,11.288A15.368,15.368,0,0,0,143.019-801.045Z",
    transform: "translate(787.253 1330.255)",
    fill: "#22638d",
    opacity: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchFolder);
export default __webpack_public_path__ + "static/media/icon-search-folder.4130251d75261c5f49eb730db040e4ea.svg";
export { ForwardRef as ReactComponent };